export default "__VITE_ASSET__DjjNrLrN__"